<template>
<div>
  <OverlayLoading :loading="loading" />
  <v-dialog v-model="dialogApprover" persistent max-width="650px">
    <v-card class="pl-5 pr-5  pt-3 pb-3">
      <v-card-title>
        <span class="ra-head-text-bold pa-1" style="color: black;">{{typeAction}}ผู้อนุมัติ</span>
        <!-- <UpdateTitleOrgchart titlename="เพิ่มผู้อนุมัติ" style="text-decoration: underline;" :btnDel="false" /> -->
      </v-card-title>
      <v-card-text>
        <v-row class="align-center" justify="center">
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <!-- <v-col cols="12">
            <span class="ra-head-text" style="">เลือกผู้อนุมัติ</span>
          </v-col> -->
          <!-- <div class="">
            <v-radio-group
              v-model="radios"
              row
              >
              <v-radio
                class="radio-border"
                label="ตนเอง"
                value="ตนเอง"
              ></v-radio>
              <v-radio
                class="radio-border"
                label="ค้นหาจากรหัสพนักงาน"
                value="ค้นหาจากรหัสพนักงาน"
              ></v-radio>
              <v-radio
                class="radio-border"
                label="ค้นหาจาก One ID"
                value="ค้นหาจาก One ID"
              ></v-radio>
            </v-radio-group>
          </div> -->
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              v-model="dataSearchEmployee"
              @change="searchEmployee(dataSearchEmployee)"
              :items="itemUser"
              item-text="dataShow"
              item-value="emailOneId"
              :search-input.sync="searchEmpoyee"
              outlined
              dense
              class="mt-2"
              placeholder="ค้นหาจากชื่อหรือ Email One ID"
              no-data-text="ไม่พบข้อมูล"
              @keyup="getUser($event.target.value)"
            >
              <template v-slot:append>
                <img width="24" height="24" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchEmployee(dataSearchEmployee), page=1">
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="pl-3 mb-2">
          <span>ผลการค้นหา</span>
        </v-row>
        <div class="pa-3" style="background-color: #F8F9FB; height: 300px;">
          <v-avatar
            v-if="searchEmpoyee !== null || employeeIdDefault !==''"
            class="mt-1 ml-2"
            size="80"
            rounded
            style="float: left;"
            >
            <v-img
              class="card-header-userimg-border"
              cover
              :lazy-src="require('@/assets/icons/no_user.png')"
              :src="failed_image ? require('@/assets/icons/no_user.png') : img"
              :alt="employeeId"
              v-on:error="onImgError()"
              aspect-ratio="1"
              height="100%"
            />
          </v-avatar>
          <v-row v-if="searchEmpoyee !== null || employeeIdDefault !==''" class="pl-2 pr-5 mb-5 align-center">
            <v-col cols="8" class="form-control">
              <p class="txt-font" style="margin-top: 0%;">รหัสพนักงาน</p>
              <span class="txt-font" style="color: #333;">{{employeeId}}</span>
            </v-col>
            <v-col cols="8" class="form-control">
              <p class="txt-font" style="margin-top: 0%;">ชื่อ-สกุล</p>
              <span class="txt-font" style="color: #333;">{{fNameTh}}</span>
            </v-col>
            <!-- <v-col cols="8" class="form-control">
              <p class="txt-font" style="margin-top: 0%;">ตำแหน่ง</p>
              <span class="txt-font" style="color: #333;">{{position}}</span>
            </v-col> -->
            <v-col cols="8" class="form-control">
              <p class="txt-font" style="margin-top: 0%;">อีเมล</p>
              <span class="txt-font" style="color: #333;">{{email}}</span>
            </v-col>
          </v-row>
          <v-row v-else class="pl-3" justify="center">
            <span class="ra-head-text mt-15">ไม่มีข้อมูล</span>
          </v-row>
        </div>
        <v-row v-if="searchEmpoyee !== null || employeeIdDefault !==''" class="align-center" justify="center">
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12">
            <span class="ra-head-text" style="">เลือกผู้อนุมัติ</span>
          </v-col>
          <v-col cols="12">
            <v-radio-group
              v-model="approveType"
              row
              class="justify-start"
              >
              <v-radio
                class="radio-border"
                color="#2BA197"
                label="ผู้อนุมัติ"
                value="ผู้อนุมัติ"
              ></v-radio>
              <v-radio
                class="radio-border"
                color="#2BA197"
                label="ผู้รับทราบ"
                value="ผู้รับทราบ"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <!-- <FullLoading :loading="loadingUsers"></FullLoading> -->
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="ra-button1" color="#2BA197" outlined @click="closeDialog">ยกเลิก</v-btn>
        <v-btn class="ra-button1" color="#2BA197" dark @click="confirmApprove()">เพิ่มผู้ดูแล</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
// import { UpdateTitleOrgchart, FullLoading } from '@/components/index'
import {
  // getUserByKeyword, // เก่า
  getUserByEmployee, // ใหม่
  // searchSelectEmployee,
  hostImageUrlv3
} from '@/API/API'
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'
import OverlayLoading from '../../_template/OverlayLoading'

export default {
  name: 'dialog-create-approver',
  components: {
    // FullLoading,
    // UpdateTitleOrgchart
    OverlayLoading
  },
  data () {
    return {
      typeAction: '',
      tokenUser: this.$store.state.token,
      isLoading: false,
      loading: false,
      loadingUsers: true,
      dialogApprover: false,
      failed_image: false,
      radios: null,
      employeeIdDefault: '',
      propsEmpId: '',
      serviceType: '',
      serviceName: '',
      note: '',
      formId: '',
      senderName: '',
      dataCreate: '',
      chkRole: 'admin',
      fNameTh: '',
      lNameTh: '',
      email: '',
      approveType: 'ผู้อนุมัติ',
      companyName: '',
      companyId: '',
      img: '',
      employeeId: '',
      id: '',
      position: '',
      userImg: '',
      dataSearchEmployee: '',
      action: '',
      type: '',
      index: '',
      indexJ: '',
      items: [],
      itemUser: [],
      search: null,
      select: null,
      searchEmpoyee: null,
      rulesSearch: [
        v => !!v || 'กรุณากรอก Username หรือ E-mail'
      ]
    }
  },
  mounted () {
    EventBus.$on('openDialogAddAprover', this.openDialogAddAprover)
  },
  beforeDestroy () {
    EventBus.$off('openDialogAddAprover')
  },
  watch: {
    radios (val) {
      if (val === 'ตนเอง') {
        this.employeeIdDefault = ''
        this.employeeIdDefault = this.$store.state.user.employeeId
        this.searchEmployee(this.$store.state.user.employeeId)
      } else if (val === 'ค้นหาจากรหัสพนักงาน') {
        this.failed_image = false
        this.dataSearchEmployee = ''
        this.employeeIdDefault = ''
        this.img = ''
        this.id = ''
        this.fNameTh = ''
        this.employeeId = ''
        this.position = ''
        this.email = ''
        this.companyName = ''
        this.companyId = ''
        this.getUser()
      } else if (val === 'ค้นหาจาก One ID') {
        this.failed_image = false
        this.dataSearchEmployee = ''
        this.employeeIdDefault = ''
        this.img = ''
        this.id = ''
        this.fNameTh = ''
        this.employeeId = ''
        this.position = ''
        this.email = ''
        this.img = ''
        this.companyName = ''
        this.companyId = ''
        // this.searchEmployeeOne()
      }
    }
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.propsEmpId = this.$route.params.id
  },
  methods: {
    onImgError () {
      this.failed_image = true
    },
    openDialogAddAprover (value, item, action, index, indexJ) {
      this.loading = true
      this.getUser(item.email)
      // this.itemUser = []
      this.img = ''
      this.searchEmpoyee = null
      this.employeeIdDefault = ''
      this.dataSearchEmployee = ''
      this.radios = null
      this.action = action
      this.index = index
      this.indexJ = indexJ
      this.dataSearchEmployee = item.email
      // this.dialogApprover = value
      if (this.action === 'edit') {
        this.searchEmployee(this.dataSearchEmployee)
        this.searchEmpoyee = item.email
        this.typeAction = 'แก้ไข'
      } else if (this.action === 'add') {
        // console.log('add')
        this.typeAction = 'เพิ่ม'
      }
    },
    closeDialog () {
      this.clearSearchEmployee()
      this.dialogApprover = false
    },
    clearSearchEmployee () {
      this.loadingUsers = true
      this.radios = null
      this.dataSearchEmployee = ''
      this.searchEmpoyee = ''
      this.fNameTh = ''
      this.lNameTh = ''
      this.employeeId = ''
      this.position = ''
      this.email = ''
      this.img = ''
      this.id = ''
      this.companyName = ''
      // this.dialogApprover = false
      this.loadingUsers = false
    },
    async getUser (value) {
      // this.loading = true
      this.loadingUsers = true
      var temp = []
      const obj = {
        // search: ''
        name: value
      }
      try {
        // const res = await getUserByKeyword(obj, this.tokenUser) // เก่า
        const res = await getUserByEmployee(obj, this.tokenUser) // ใหม่
        if (res.success) {
          if (res.selector.length) {
            res.selector.map((el, index) => {
              if (el.userImg === '') {
                el.userImg = `${hostImageUrlv3}/_/${el.emailOneId}`
              } else {
                el.userImg = `${hostImageUrlv3}/${el.userImg}/${el.emailOneId}`
              }
              temp.push({
                no: index + 1,
                dataShow: el.titleTh + el.name + ' - ' + el.emailOneId,
                ...el
              })
            })
          }
          // temp = res.result
          this.itemUser = temp
          this.dialogApprover = true
          this.loading = false
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
        this.loadingUsers = false
      }
    },
    async searchEmployee (value) {
      // this.loading = true
      // this.loadingUsers = true
      const obj = {
        // search: value
        name: value
      }
      try {
        // const res = await getUserByKeyword(obj, this.tokenUser) // เก่า
        const res = await getUserByEmployee(obj, this.tokenUser) // ใหม่
        // console.log('Res add approver', res)
        if (res.selector[0]) {
          // เก่า
          // this.id = res.result[0].userId
          // this.fNameTh = res.result[0].name
          // this.employeeId = res.result[0].employeeId
          // this.position = res.result[0].position.positionName
          // this.email = res.result[0].emailOneId
          // this.img = res.result[0].userImg
          // this.companyName = res.result[0].companyName
          // this.companyId = res.result[0].companyId
          // ใหม่
          this.id = res.selector[0].employee_id
          this.fNameTh = res.selector[0].titleTh + res.selector[0].name
          this.employeeId = res.selector[0].employeeId
          // this.position = res.selector[0].position.positionName
          this.email = res.selector[0].emailOneId
          this.img = res.selector[0].userImg
          // this.companyName = res.selector[0].companyName
          // this.companyId = res.selector[0].companyId
          if (this.img === '') {
            this.img = `${hostImageUrlv3}/_/${res.selector[0].emailOneId}`
          } else {
            this.img = `${hostImageUrlv3}/${res.selector[0].userImg}/${res.selector[0].emailOneId}`
          }
        } else {
          this.dataSearchEmployee = ''
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        }
      } catch (error) {
        console.log(error)
        this.dataSearchEmployee = ''
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
      } finally {
        // this.loading = false
        this.loadingUsers = false
      }
    },
    // async searchEmployeeOne () {
    //   const obj = {
    //     search: 'sittikorn0993'
    //   }
    //   try {
    //     const res = await searchSelectEmployee(obj, this.$store.state.token)
    //     console.log('Res add approver One', res)
    //     if (res.result[0]) {
    //       this.id = res.result[0]._id
    //       this.fNameTh = res.result[0].name
    //       this.employeeId = res.result[0].employeeId
    //       this.position = res.result[0].position.positionName
    //       this.email = res.result[0].email
    //       this.img = res.result[0].userImg
    //       this.companyName = res.result[0].companyName
    //       this.companyId = res.result[0].companyId
    //       if (this.img === '') {
    //         this.img = `${hostImageUrlv3}/_/${res.result[0].emailOneId}`
    //       } else {
    //         this.img = `${hostImageUrlv3}/${res.result[0].userImg}/${res.result[0].emailOneId}`
    //       }
    //     } else {
    //       this.dataSearchEmployee = ''
    //       swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
    //         button: false,
    //         timer: 2000
    //       })
    //     }
    //   } catch (error) {
    //     console.log(error)
    //     this.dataSearchEmployee = ''
    //     swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
    //       button: false,
    //       timer: 2000
    //     })
    //   } finally {
    //     // this.loading = false
    //     this.loadingUsers = false
    //   }
    // },
    confirmApprove () {
      if (this.dataSearchEmployee === '' || this.employeeId === '') {
        swal('คำเตือน', 'กรุณากรอกชื่อและ Email One ID ที่ต้องการค้นหา', 'warning', {
          button: false,
          timer: 2000
        })
      } else {
        var valueList = {
          id: this.id,
          name: this.fNameTh,
          employeeId: this.employeeId,
          nickname: '',
          // position: this.position,
          email: this.email,
          approveType: this.approveType,
          // companyId: this.companyId,
          userImg: this.img
        }
        EventBus.$emit('addAprover', valueList, this.index, this.action, this.indexJ)
        this.type = ''
        this.dialogApprover = false
        this.fNameTh = ''
        this.lNameTh = ''
        this.employeeId = ''
        this.position = ''
        this.email = ''
        this.companyName = ''
        // swal('Success', 'โอนย้ายสิทธิ์ สำเร็จ', 'success')
      }
    }
  }
}
</script>
<style scoped>
@import '../../../css/ManageEmployee.css';
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 5px;
  color: #757575;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.ra-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #2BA197;
  border-radius: 4px;
}
.ra-text-in-button {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
.ra-head-text-bold {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  color: #2BA197;
}
.ra-head-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
}
.box-image3 {
  border-width: 1px 1px;
  border-radius: 5px;
  border: 2px solid #e7e7e7;
  height: 40px;

}
.radio-border {
  height: 45px;
  border: 2px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}
.radio-border-click {
  height: 45px;
  border: 2px solid #2BA197;
  border-radius: 5px;
  padding: 15px;
}
.v-input--radio-group.v-input--radio-group--row .v-radio .radio-border-click {
  border-color: red;
}
/* .v-input--radio-group .v-input--radio-group--row .v-radio {
  border-color: red;
} */
/* .radio-border[data-v-c437d5c2] {
  height: 45px;
  border: 2px solid blue;
  border-radius: 5px;
  padding: 15px;
} */
</style>
